module.exports = __webpack_public_path__ + "media/entities/1006-cecb2bac.png";